import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { fetchPrivateAvatars } from '../../services';
import { FilteringSortingParams } from 'apps/t2c-fe/utils';

export const useGetPrivateAvatarData = (params: FilteringSortingParams) => {
  return useInfiniteQuery(
    ['fetchPrivateAvatars', params],
    ({ pageParam = 1 }) => fetchPrivateAvatars({ ...params, page: pageParam }),
    {
      getNextPageParam: (lastPage, allPages) => {
        const currentPage = allPages.length;
        const totalItemsFetched = currentPage * (params?.limit ?? 20);

        if (totalItemsFetched < lastPage.count) {
          return currentPage + 1;
        } else {
          return undefined;
        }
      },
    }
  );
};
